import { render, staticRenderFns } from "./ieDetail.vue?vue&type=template&id=6728affc&"
import script from "./ieDetail.vue?vue&type=script&lang=js&"
export * from "./ieDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6728affc')) {
      api.createRecord('6728affc', component.options)
    } else {
      api.reload('6728affc', component.options)
    }
    module.hot.accept("./ieDetail.vue?vue&type=template&id=6728affc&", function () {
      api.rerender('6728affc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/ieDetail.vue"
export default component.exports